import Image from 'next/image';

import { Box, Grid, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';

const JacActivity = () => {
    const t = useTranslations('CsrPage.JacActivity');

    const dataResource = [
        {
            photo: '/images/csr/jac.avif',
            span: 4,
            description: {},
            type: 'photo'
        }, {
            photo: '',
            span: 8,
            description: {
                title: t('row1_title'),
                sub_title: t('row1_sub_title'),
            },
            type: 'text'
        }, {
            photo: '/images/csr/jac_1.avif',
            span: 4,
            description: {},
            type: 'photo'
        }, {
            photo: '/images/csr/jac_2.avif',
            span: 4,
            description: {},
            type: 'photo'
        }, {
            photo: '/images/csr/jac_3.avif',
            span: 4,
            description: {},
            type: 'photo'
        }, {
            photo: '',
            span: 8,
            description: {
                title: t('row2_title'),
                sub_title: t('row2_sub_title'),
                sub_title_1: t('row2_sub_title_1'),
            },
            type: 'text'
        }, {
            photo: '/images/csr/ngo_1.avif',
            span: 4,
            description: {},
            type: 'photo'
        }, {
            photo: '/images/csr/ngo_2.avif',
            span: 4,
            description: {},
            type: 'photo'
        }, {
            photo: '/images/csr/ngo_3.avif',
            span: 4,
            description: {},
            type: 'photo'
        }, {
            photo: '/images/csr/ngo_4.avif',
            span: 4,
            description: {},
            type: 'photo'
        },
    ];

    return (
        <Box sx={{ mb: 6 }}>
            <Grid container >
                <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                    <Grid container>
                        {dataResource.map((item, index) => (
                            <Grid size={{ xs: 12, sm: item.span, md: item.span }} sx={{ padding: 1 }} key={index}>
                                {
                                    item.type == 'text' ? (
                                        <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'start' }}>
                                            <Typography
                                                variant="h5"
                                                sx={{ fontWeight: 600, lineHeight: 1.1, mb: 2 }}
                                            >
                                                {item.description['title']}
                                            </Typography>
                                            <Typography
                                                variant="body1" sx={{ color: "#64748b" }}
                                            >
                                                {item.description['sub_title']}
                                                <br />
                                                {
                                                    item.description['sub_title_1'] && item.description['sub_title_1']
                                                }
                                            </Typography>
                                        </div>
                                    ) : (
                                        <Image src={item.photo} alt='photo' width={400} height={300} style={{ width: '100%', height: 'auto' }} />
                                    )
                                }
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
        </Box >
    );
}

export default JacActivity;